module.exports = __webpack_public_path__ + "assets/64aea8fa3d21b55359c5e38ea305de54.svg";